export const SELECTED_CHAT_STORAGE_KEY = 'bips-chatter-selected-chat';
